import { useEffect, useState } from "react";
import { useTranslate } from "@refinedev/core";
import { AUDIENCE_TAG_KEYS } from "./constants";
import styled from "styled-components";
import { popIn, slideReveal } from "./Autopilot.styled";
import { radius } from "@libertify/ui";

export const AudienceVisual: React.FC<{ isActive: boolean }> = ({
  isActive,
}) => {
  const t = useTranslate();
  const [visibleCount, setVisibleCount] = useState(0);
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);

  useEffect(() => {
    if (!isActive) return;
    const timers: ReturnType<typeof setTimeout>[] = [];
    AUDIENCE_TAG_KEYS.forEach((_, i) => {
      timers.push(
        setTimeout(() => setVisibleCount((c) => c + 1), i * 350 + 100)
      );
    });
    timers.push(
      setTimeout(() => setSelectedIdx(2), AUDIENCE_TAG_KEYS.length * 350 + 400)
    );
    return () => timers.forEach(clearTimeout);
  }, [isActive]);

  return (
    <VisualWrap>
      {AUDIENCE_TAG_KEYS.map((tag, i) => {
        if (i >= visibleCount) return null;
        const isSelected = selectedIdx === i;
        const isDimmed = selectedIdx !== null && !isSelected;
        return (
          <AudienceTagChip
            key={tag.labelKey}
            $selected={isSelected}
            $dimmed={isDimmed}
          >
            <span>{tag.icon}</span>
            {t(tag.labelKey)}
          </AudienceTagChip>
        );
      })}
    </VisualWrap>
  );
};

const VisualWrap = styled.div`
  padding: 14px 15px 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  animation: ${slideReveal} 0.3s ease both;
`;

const AudienceTagChip = styled.div<{ $selected: boolean; $dimmed: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border-radius: ${radius.pill}px;
  border: 1.5px solid ${(p) => (p.$selected ? "#14B8A6" : "#E5E7EB")};
  background: ${(p) => (p.$selected ? "#F0FDFA" : "white")};
  font-size: 12.5px;
  font-weight: 500;
  color: ${(p) => (p.$selected ? "#0d9488" : "#374151")};
  opacity: ${(p) => (p.$dimmed ? 0.4 : 1)};
  transform: ${(p) =>
    p.$selected ? "scale(1.04)" : p.$dimmed ? "scale(0.96)" : "scale(1)"};
  transition:
    border-color 0.35s ease,
    background 0.35s ease,
    color 0.35s ease,
    opacity 0.35s ease,
    transform 0.35s ease;
  animation: ${popIn} 0.3s ease both;
`;
